export default __webpack_public_path__ + "static/ArminGrotesk-UltraLight-8cc5d292df142b3029f404424d39f125.woff2";